import React from 'react';

export default () => (
  <svg width="11" height="13" viewBox="-1 -1 13 15" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g fill="#000">
        <g>
          <path d="M2.857 5.714V4a2.29 2.29 0 0 1 2.286-2.286A2.29 2.29 0 0 1 7.429 4v1.714H2.857zm7.429.857a.857.857 0 0 0-.857-.857h-.286V4c0-2.196-1.804-4-4-4-2.197 0-4 1.804-4 4v1.714H.857A.857.857 0 0 0 0 6.571v5.143c0 .474.384.857.857.857H9.43a.857.857 0 0 0 .857-.857V6.571z" />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/lock.es6.js